var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BottomList',{attrs:{"QueryData":_vm.QueryData,"detailData":_vm.detailData}})}
var staticRenderFns = []

export { render, staticRenderFns }